import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  MatFormFieldAppearance,
  MatFormField,
  MatLabel,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  imports: [MatFormField, MatLabel, MatInput, FormsModule],
})
export class InputComponent {
  @Input() type: HTMLInputTypeAttribute = 'text';
  @Input() appearance: MatFormFieldAppearance = 'outline';
  @Input() label: string;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() value: string;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
}

type HTMLInputTypeAttribute = 'number' | 'text' | 'tel' | 'email' | 'password';
